import * as actionTypes from './actionTypes';
import userService from '../../services/userService';

// Fetch Departments
export const fetchDepartments = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_DEPARTMENTS_REQUEST });
  try {
    const response = await userService.getDepartments();
    dispatch({
      type: actionTypes.FETCH_DEPARTMENTS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_DEPARTMENTS_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch departments',
    });
  }
};

// Fetch Teams
export const fetchTeams = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_TEAMS_REQUEST });
  try {
    const response = await userService.getTeams();
    dispatch({
      type: actionTypes.FETCH_TEAMS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_TEAMS_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch teams',
    });
  }
};

// Fetch Managers
export const fetchManagers = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_MANAGERS_REQUEST });
  try {
    const response = await userService.getManagers();
    dispatch({
      type: actionTypes.FETCH_MANAGERS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_MANAGERS_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch managers',
    });
  }
};

// Fetch Employee Types
export const fetchEmployeeTypes = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_EMPLOYEE_TYPES_REQUEST });
  try {
    const response = await userService.getEmployeeTypes();
    dispatch({
      type: actionTypes.FETCH_EMPLOYEE_TYPES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_EMPLOYEE_TYPES_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch employee types',
    });
  }
};

// Fetch Employee Types
export const fetchEmploymentStatuses = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_EMPLOYMENT_STATUSES_REQUEST });
  try {
    const response = await userService.getEmploymentStatuses();
    dispatch({
      type: actionTypes.FETCH_EMPLOYMENT_STATUSES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_EMPLOYMENT_STATUSES_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch employment statuses',
    });
  }
};

export const fetchAccessLevels = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_ACCESS_LEVELS_REQUEST });
  try {
    const response = await userService.getAccessLevels();
    dispatch({
      type: actionTypes.FETCH_ACCESS_LEVELS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_ACCESS_LEVELS_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch access levels',
    });
  }
};
// Fetch All Reference Data
export const fetchReferenceData = () => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_REFERENCE_DATA_REQUEST });
  try {
    const [departments, teams, managers, employeeTypes, employmentStatuses, accessLevels] = await Promise.all([
      userService.getDepartments(),
      userService.getTeams(),
      userService.getManagers(),
      userService.getEmployeeTypes(),
      userService.getEmploymentStatuses(),
      userService.getAccessLevels(),
    ]);

    dispatch({
      type: actionTypes.FETCH_REFERENCE_DATA_SUCCESS,
      payload: {
        departments: departments.data,
        teams: teams.data,
        managers: managers.data,
        employeeTypes: employeeTypes.data,
        employmentStatuses: employmentStatuses.data,
        accessLevels: accessLevels.data,
      },
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_REFERENCE_DATA_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch reference data',
    });
  }
};